import superAdminLayout from "@/layouts/superAdminLayout";
import homeLayout from "@/layouts/superAdmin/homeLayout";
import membershipLayout from "@/layouts/superAdmin/membershipLayout";
import nominationLayout from "@/layouts/superAdmin/nominationLayout";
import nominationRoutes from "@/router/routes/nominationRoutes";

const Dashboard = () => import(/* webpackChunkName: "js/superadmin" */'@/views/superadmin/Dashboard');
const Membership = () => import(/* webpackChunkName: "js/superadmin" */'@/views/superadmin/Membership');
const Nomination = () => import(/* webpackChunkName: "js/superadmin" */'@/views/superadmin/Nomination');

const SuperAdminHomeAnalytics = () => import(/* webpackChunkName: "js/superadmin/home" */'@/views/superadmin/Home/Analytics');

const AdminMember = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/Members')
const FailedUSSD = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/FailedUSSD')
const BulkPayment = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/AcceptBulkPayment')
const CheckPayment = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/VerifyTransaction')
const UnaccountedPayments = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/UnAccountedPayments')
const AdminTempMember = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/AdminTempMember')
const AdminVeteran = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/AdminVeteranMembers')
const AdminTempStoreMember = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/UserStore')
const AdminMemberLevels = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/MembershipLevels')
const AdminPayments = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/Payments')
const AdminMemberSummary = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/summary/CountyMemberSummary')
const AdminTempMemberSummary = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/summary/CountyTempMemberSummary')
const AdminMemberLevelSummary = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/summary/MemberLevelSummary')
const AdminPaymentReports = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/reports/AdminPaymentReport')
const AdminMemberReports = () => import(/* webpackChunkName: "js/superadmin/membership" */'@/views/superadmin/Membership/reports/AdminMemberReports')

export default [
    // {
    //     path: "/super-admin",
    //     component: Dashboard,
    //     name: "Super Admin",
    //     meta: {
    //         title: 'Admin - Party System',
    //         metaTags: [
    //             {
    //                 name: 'description',
    //                 content: 'This is the admin page'
    //             }
    //         ]
    //     }
    // },
    {
        path: '/super-admin',
        component: homeLayout,
        children: [
            {
                path: "/super-admin",
                component: Dashboard,
                name: "SuperAdmin",
                meta: {
                    title: 'Admin - Party System',
                    metaTags: [
                        {
                            name: 'description',
                            content: 'This is the admin page'
                        }
                    ]
                }
            },
            {
                path: "/super-admin/analytics",
                component: SuperAdminHomeAnalytics,
                name: "SuperAdminHomeAnalytics",
                meta: {
                    title: 'Admin - Party System',
                    metaTags: [
                        {
                            name: 'description',
                            content: 'This is the admin page'
                        }
                    ]
                }
            },
        ],
        // meta: {
        //   middleware: [
        //     guest
        //   ]
        // },
    },
    {
        path: '/super-admin/membership',
        component: membershipLayout,
        children: [
            {
                path: "/super-admin/membership",
                component: Membership,
                name: "SuperAdminMembers",
                meta: {
                    title: 'Admin - Party System',
                    metaTags: [
                        {
                            name: 'description',
                            content: 'This is the admin page'
                        }
                    ]
                }
            },
            {
                name: "AdminMember",
                path: "/super-admin/membership/members",
                component: AdminMember
            },
            {
                name: "AdminTempStoreMember",
                path: "/super-admin/membership/members/archived/members",
                component: AdminTempStoreMember
            },
            {
                name: "FailedUSSD",
                path: "/super-admin/membership/members/failed-ussd",
                component: FailedUSSD
            },
            {
                name: "BulkPayment",
                path: "/super-admin/membership/members/bulkPayment",
                component: BulkPayment
            },
            {
                name: "UnaccountedPayments",
                path: "/super-admin/membership/members/unaccounted-payments",
                component: UnaccountedPayments
            },
            {
                name: "AdminVeteran",
                path: "/super-admin/membership/members/veterans",
                component: AdminVeteran
            },
            {
                name: "CheckPayment",
                path: "/super-admin/membership/members/check-payment",
                component: CheckPayment
            },
            {
                name: "AdminPayments",
                path: "/super-admin/membership/members/payments",
                component: AdminPayments
            },
            {
                name: "AdminTempMember",
                path: "/super-admin/membership/members/temp-members",
                component: AdminTempMember
            },
            {
                name: "AdminPaymentReports",
                path: "/super-admin/membership/members/reports/payments",
                component: AdminPaymentReports
            } ,
            {
                name: "AdminMemberReports",
                path: "/super-admin/membership/members/reports/members",
                component: AdminMemberReports
            },
            {
                name: "AdminMemberLevels",
                path: "/super-admin/membership/members/member-levels",
                component: AdminMemberLevels
            },
            {
                name: "AdminMemberSummary",
                path: "/super-admin/membership/members/summary/members",
                component: AdminMemberSummary
            },
            {
                name: "AdminMemberLevelSummary",
                path: "/super-admin/membership/members/summary/membersperlevel",
                component: AdminMemberLevelSummary
            },
            {
                name: "AdminTempMemberSummary",
                path: "/super-admin/membership/members/summary/unpaid",
                component: AdminTempMemberSummary
            }
        ],
        // meta: {
        //   middleware: [
        //     guest
        //   ]
        // },
    },
    {
        path: '/super-admin/nomination',
        component: nominationLayout,
        children: [
            {
                path: "/super-admin/nomination",
                component: Nomination,
                name: "SuperAdminNomination",
                meta: {
                    title: 'Admin - Party System',
                    metaTags: [
                        {
                            name: 'description',
                            content: 'This is the admin page'
                        }
                    ]
                }
            },
            ...nominationRoutes
        ],
        // meta: {
        //   middleware: [
        //     guest
        //   ]
        // },
    },

]
